<template>
  <div class="login_setup">
    <v-snackbar
      class="mt-5"
      :color='color'
      :timeout="3000"
      :top="true"
      v-model="alert"
    >{{message}}</v-snackbar>
    <div class="d-flex justify-center" :class="full_screen ? 'w-100' : 'container'">
      <!-- <div class="container-fluid" :class="bannerShow ? ' ' :'justify-center'"> -->
        <div :id="full_screen ? 'check' : ''" :class="full_screen ? 'bannerElement' : 'row justify-center'">
          <!-- <img :src="bannerAsset" class="img-fluid"> -->
          <div v-if="!full_screen && bannerShow" :class="full_screen ? '' : 'col-md-8'">
            <img :src="bannerAsset" class="img-fluid">
          </div>
          <v-card v-if="!$route.query.ott" :class="full_screen ? 'custom_fullScreen col-md-3' : 'col-md-4'" class="md-layout-item form_setup box_s border-all-1">
            <form @submit.prevent="loginNew(form)" class="" id="cloud-login">
              <div class="container-fluid mt10">
                <img :src="navLogo" width="40%" class="img-fluid mt10 mb20">
                <h5 class="font-weight-bold mb20">Sign in to {{cloudName}}</h5>
                <v-text-field
                  label="Enter Your Email"
                  v-model="form.email"
                  data-vv-name="email"
                  :disabled="!checkConfigdata"
                  v-validate="'required|email'"
                  :error-messages="errors.collect('email')"
                >
                </v-text-field>

                <v-text-field
                  label="Enter Your Password"
                  :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  v-model="form.password"
                  :disabled="!checkConfigdata"
                  data-vv-name="password"
                  v-validate="{required:true, regex: $store.state.passwordRegex}"
                  :error-messages="errors.collect('password')"
                >
                </v-text-field>
                <v-text-field
                  v-if='showOTP'
                  label="Enter OTP"
                  v-model="OTP"
                  :disabled="!checkConfigdata"
                  data-vv-name="OTP"
                  v-validate="'required'"
                  :error-messages="errors.collect('OTP')"
                >
                </v-text-field>
                <span v-if='counterMessage' class='pb-0'>You can request another OTP in <strong>{{counter}}</strong> sec</span>
                <p v-if='showResendBtn' class="text-primary-apiculus link" @click='resendOTP()'>Resend OTP</p>

                <v-card-actions class="p-0">
                  <v-btn type="submit" :disabled="!checkConfigdata" color="primary" block class="auth_form m-0 box_s rounded-0">{{loginMessage}}</v-btn>
                </v-card-actions>
                <div class="p10" v-if="adminOnly">
                  <router-link class="text-primary-apiculus" to="sendVerificationLink">Forgot Password?</router-link>
                </div>
                <div class="p10 pb-0 mt10" v-if="!adminOnly">
                  <router-link class="text-primary-apiculus" to="sendVerificationLink">Forgot Password?</router-link>
                </div>
                <div class="p10" v-if="!adminOnly">
                  <span>Don’t have an account? </span>
                  <!-- <router-link class="link text-primary-apiculus" to="signup">Sign Up</router-link> -->
                  <a class="link text-primary-apiculus" href="/signup">Sign Up</a>
                </div>
              </div>
            </form>
          </v-card>
        </div>
        <!-- <v-flex xs4 class=""> -->
          <!-- <div class="row d-flex justify-content-center">
            <div class="xs-7 text-end">
            </div> -->
            <!-- <div class="xs-4"> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import HTTP from '@/services/http-request-handler'
import VueCookie from 'vue-cookie'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import VueCookies from 'vue-cookies'
// import { setTimeout } from 'timers';
export default {
  name: 'auth',
  data () {
    return {
      eventBus: eventBus,
      checkTwoFACall: false,
      showResendBtn: false,
      counterMessage: false,
      counter: this.$store.state.ApiculusEnv.OTPTimer || 20,
      showOTP: false,
      loginMessage: '',
      OTP:'',
      form: {
        email: null
      },
      cloudName: '',
      color: '',
      alert: false,
      // bannerVisible: false,
      full_screen: '',
      message: '',
      navLogo: '',
      bannerAsset: '',
      showPassword: false,
      bannerShow: false,
      bannerElement: false,
      checking: '',
      banner: this.$store.state.ApiculusEnv.labels.brand_image_path,
      adminOnly: Boolean,
      otpLogin : false
    }
  },
  computed: {
    ...mapGetters({
      listAllAssets: 'getAllAssets'
    }),
    checkConfigdata () {
      return (Object.keys(this.$store.state.ApiculusEnv).length > 0)
    },
    twoFactorAuth () {
      return this.checkConfigdata && Boolean(this.$store.state.ApiculusEnv.features.twoFactorAuth)
    }
  },
  watch: {
    alert () {
      if (this.alert) {
        setTimeout(() => this.alert, 1000)
      }
    }
  },
  methods: {
    otpTimer () {
      let interval = setInterval(() => {
        this.counter--;
        if (this.counter <= 0) {
          clearInterval(interval);
          this.counterMessage = false,
          this.showResendBtn = true
          return;
        }
      }, 1000);
    },
    resendOTP() {
      this.$store.dispatch('ACTION_RESEND_OTP', {email: this.form.email}).then((res)=>{
        if(res.success) {
          this.counterMessage = true
          this.counter = this.$store.state.ApiculusEnv.OTPTimer
          this.showResendBtn = false
          this.otpTimer()
        }
      })
    },
    signUp () {
      this.$router.push({ name: 'SignUp' })
    },
    loginNew() {
      if(!this.otpLogin){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('ACTION_GET_STATE', {
              email: this.form.email,
              password: this.form.password,
            }).then((res) => {
              if (res.error) {
                this.color = 'error'
                this.message = res.error.message || 'Something went wrong.'
                this.alert = true
                return 
              }

              if ((res.result.account_type == 0 || res.result.account_type == 1)) {
                if (!this.$store.state.ApiculusEnv.features.twoFactorAuthSubs) {
                  this.logIN()
                }
                else {
                  this.checkTwoFACall = true
                  this.isOtpLogin = true
                  this.loginOTP()
                }
              }
              if ((res.result.account_type == 11 || res.result.account_type == 12)) {
                if (!this.$store.state.ApiculusEnv.features.twoFactorAuthAdmin) {
                  this.logIN()
                }
                else {
                  this.checkTwoFACall = true
                  this.isOtpLogin = true
                  this.loginOTP()
                }
              }
            })
        }})
      }
      else {
        this.loginOTP()
      }
    },
    logIN(){
            if (this.$route.query.ott) {
              this.form.email = this.$store.state.ApiculusEnv.ottLogin.username
              this.form.password = this.$store.state.ApiculusEnv.ottLogin.password
            }
            this.$store.dispatch('ACTION_AUTH_LOGIN', {
              email: this.form.email,
              password: this.form.password,
              ott: this.$route.query.ott,
            }).then((res) => {
              console.log('LOGIN COMPONENT RES :::: ', res)
              if (res.success) {
                VueCookie.delete('childGroupName')
                VueCookie.delete('parentGroupName')
                VueCookie.delete('userName')
                VueCookie.delete('userRole')
                VueCookie.delete('userID')
                HTTP.defaults.headers['x-access-token'] = res.result.token

                this.$store.state.userDetails= 'getData'
                
                // this.$store.dispatch('ACTION_USERDETAIL_MEE').then((res)=>{
                //   console.log('res=>>>>>>', res)
                //   // this.$store.state.parentGroupName= res.parentGroup
                //   VueCookie.set('parentGroupName', res.parentGroup)
                //   if (res && res.hasOwnProperty('childGroup')) {
                //     VueCookie.set('childGroupName', res.childGroup)
                //   }
                //   // this.$store.state.userRole= res.role
                //   VueCookie.set('userRole', res.role)
                //   VueCookie.set('userID', res.id)
                //   // this.$store.state.userName= res.name
                //   VueCookie.set('userName', res.name)
                // })
                HTTP.get('op_getAccountState').then(response => {
                  VueCookie.set('access-token', res.result.token)
                  VueCookies.set('access-token-key', res.result.token, null,null,null,true,'None')
                  VueCookie.set('currency', res.result.currency)
                  VueCookie.set('last_logged_in', res.result.last_logged_in)
                  VueCookie.set('account_type', res.result.account_type)
                  VueCookie.set('account_id', response.data.result.ID)
                  if (response.data.result.account_state > 0) {
                    // response.data.result.account_state = 17.02
                    let username = `${response.data.result.first_name} ${response.data.result.last_name}`
                    VueCookie.set('username', username)
                    VueCookie.set('email', response.data.result.email)
                    if (response.data.result.hasOwnProperty('parent_account_id')) {
                      let parentId = response.data.result.parent_account_id
                      VueCookie.set('parentId', parentId)
                    }
                    if (response.data.result.account_state.toString().split('.')[1] === '02') {
                      VueCookie.set('account_state', 'SUSPENDED')
                    } else {
                      VueCookie.set('account_state', response.data.result.account_state)
                    }
                  }

                  if (res.result.account_type == 2) {
                    VueCookie.set('resellerId', res.result.resellerId)
                    VueCookie.set('resellerCode', res.result.resellerCode)
                  }

                  if (res.result.account_type == 12 || res.result.account_type == 11 || res.result.account_type == 2) {
                     window.location.replace('/admin/')
                  } else {
                    window.location.replace('/site/')
                  }
                })
              } else {
                this.color = 'error'
                this.message = res.error.message || 'Something went wrong, Please try again later.'
                this.alert = true
              }
              // if (res.result.account_type === 12) {
              //   window.location.replace('http://localhost:8081/admin/')
              //   // window.location.replace('http://cloud.apiculus.iqtest:8443/static/#/')
              // } else {
              //   window.location.replace('http://localhost:8081/site/')
              // }
              // this.showNotification('success', 'success', 'Login Successfull')
            }).catch(e => {
              console.log('LOGIN COMPONENT ERR :::: ', e)
              this.color = 'error'
              this.message = e.response.error.message || 'Something went wrong.'
              this.alert = true
            })
          
    },
    loginOTP () {
      // this.$validator.validateAll().then((result) => {
      //   if (result) {
      //     //  else {
            if (this.checkTwoFACall) {
              this.$store.dispatch('ACTION_TWO_FACTOR_AUTH', {email: this.form.email, password: this.form.password}).then( res => {
                console.log('2FsssA login', res)
                if(res.success) {
                  this.counterMessage = true
                  this.showOTP = true
                  this.loginMessage = 'LOGIN'
                  this.checkTwoFACall = false
                  this.otpLogin = true
                  this.otpTimer()
                } else {
                  this.color = 'error'
                  this.message = res.error.message || 'Something went wrong, Please try again later.'
                  this.alert = true
                }
              }).catch(e => {
                console.log('LOGIN COMPONENT ERR :::: ', e)
                this.color = 'error'
                this.message = e.response.error.message || 'Something went wrong.'
                this.alert = true
              })
            } else {
              debugger
              this.$store.dispatch('ACTION_AUTH_LOGIN', {
                email: this.form.email,
                password: this.form.password,
                otp: Number(this.OTP),
                istwoFactorEnabled : true
              }).then((res) => {
                console.log('LOGIN COMPONENT RES :::: ', res)
                if (res.success) {
                  VueCookie.delete('childGroupName')
                  VueCookie.delete('parentGroupName')
                  VueCookie.delete('userName')
                  VueCookie.delete('userRole')
                  VueCookie.delete('userID')
                  HTTP.defaults.headers['x-access-token'] = res.result.token

                  this.$store.state.userDetails= 'getData'
                  
                  // this.$store.dispatch('ACTION_USERDETAIL_MEE').then((res)=>{
                  //   console.log('res=>>>>>>', res)
                  //   // this.$store.state.parentGroupName= res.parentGroup
                  //   VueCookie.set('parentGroupName', res.parentGroup)
                  //   if (res && res.hasOwnProperty('childGroup')) {
                  //     VueCookie.set('childGroupName', res.childGroup)
                  //   }
                  //   // this.$store.state.userRole= res.role
                  //   VueCookie.set('userRole', res.role)
                  //   VueCookie.set('userID', res.id)
                  //   // this.$store.state.userName= res.name
                  //   VueCookie.set('userName', res.name)
                  // })

                  HTTP.get('op_getAccountState').then(response => {
                    VueCookie.set('access-token', res.result.token)
                    VueCookies.set('access-token-key', res.result.token, null,null,null,true,'None')
                    VueCookie.set('currency', res.result.currency)
                    VueCookie.set('last_logged_in', res.result.last_logged_in)
                    VueCookie.set('account_type', res.result.account_type)
                    VueCookie.set('account_id', response.data.result.ID)
                    if (response.data.result.account_state > 0) {
                      // response.data.result.account_state = 17.02
                      let username = `${response.data.result.first_name} ${response.data.result.last_name}`
                      VueCookie.set('username', username)
                      VueCookie.set('email', response.data.result.email)
                      if (response.data.result.hasOwnProperty('parent_account_id')) {
                        let parentId = response.data.result.parent_account_id
                        VueCookie.set('parentId', parentId)
                      }
                      if (response.data.result.account_state.toString().split('.')[1] === '02') {
                        VueCookie.set('account_state', 'SUSPENDED')
                      } else {
                        VueCookie.set('account_state', response.data.result.account_state)
                      }
                    }
                    if (res.result.account_type == 12 || res.result.account_type == 11 || res.result.account_type == 2) {
                      window.location.replace('/admin/')
                    } else {
                      window.location.replace('/site/')
                    }
                  })
                } else {
                  this.color = 'error'
                  this.message = res.error.message || 'Something went wrong, Please try again later.'
                  this.alert = true
                }
                // if (res.result.account_type === 12) {
                //   window.location.replace('http://localhost:8081/admin/')
                //   // window.location.replace('http://cloud.apiculus.iqtest:8443/static/#/')
                // } else {
                //   window.location.replace('http://localhost:8081/site/')
                // }
                // this.showNotification('success', 'success', 'Login Successfull')
              }).catch(e => {
                console.log('LOGIN COMPONENT ERR :::: ', e)
                this.color = 'error'
                this.message = e.response.error.message || 'Something went wrong.'
                this.alert = true
              })
            // }
            // this.showNotification('error', 'error', 'Please Fill All Mandatory Details')
      //     }
      //   }
      // })
    }},
    ChangeBackgroungImageOfTab (imagePrefix) {
      let urlString = ''
      setTimeout(() => {
        urlString = document.getElementById('check')
        urlString.classList.add('bannerElement')
        urlString.style.backgroundImage = 'url(' + imagePrefix + ')'
      }, 0)
    }
  },
  created () {
    this.adminOnly = this.$store.state.ApiculusEnv.adminOnly
    if (this.twoFactorAuth) {
      this.loginMessage = 'CONTINUE'
    } else {
      this.loginMessage = 'LOGIN'
    }
    let faviconElement = document.getElementById('favicon')
    let titleElement = document.getElementById('cloudTitle')
    this.$store.dispatch('ACTION_LIST_ASSET', 'banner.png').then((res) => {
      this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'banner.png' }).then(res => {
        let downloadFiles
        if (res && typeof res === 'string') {
          downloadFiles = 'data:image/png;base64,' + res
          this.bannerAsset = downloadFiles
          this.bannerShow = true
        } else {
          this.bannerAsset = ''
          this.bannerShow = false
        }
        if (this.listAllAssets && this.listAllAssets.length > 0) {
          this.full_screen = this.listAllAssets[0].metadata.show_fullscreen
          if (this.full_screen === true) {
            this.ChangeBackgroungImageOfTab(this.bannerAsset)
          }
        }
      })
    })
    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'logo.png' }).then(res => {
      if (res) {
        let downloadFile = 'data:image/png;base64,' + res
        this.navLogo = downloadFile
      } else {
        this.navLogo = ''
      }
    })
    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'favicon.png' }).then(res => {
      let downloadFiles
      if (res) {
        downloadFiles = 'data:image/png;base64,' + res
        faviconElement.href = downloadFiles
      } else {
        faviconElement.href = ''
      }
    })
    this.$store.dispatch('ACTION_GET_PROFILE_DETAILS').then(res => {
      if (res) {
        titleElement.innerHTML = res.name
        this.cloudName = res.name
      }
    })
    // document.getElementById(bannerElement).style.background-image = 'url('+ bannerAsset +')';
    if (this.$route.query.ott) {
      this.login();
      this.twoFactorAuth = false;
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
  .login_setup {
    display: flex !important;
    height: 100% !important;
  }

  .box_s {
    box-shadow: none !important;
  }

  .bannerElement {
    // background-position: center center;
    background-repeat: no-repeat;
    // background-attachment: fixed;
    background-size: cover;
    // position: relative;
    display: flex;
    justify-content: center;
  }
  .custom_fullScreen {
    // position: absolute !important;
    align-self: center;
    opacity: 0.9;
    border: none;
  }
  .paddingText {
    padding-bottom: 10px;
  }
</style>
